<template>
  <section class="container">
    <div class="is-flex leaderboard" v-if="users.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th>#</th>
            <th>{{ $t('common.name') }}</th>
            <th>XP</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users"
              :key="user.id">
            <th>
              <span v-if="index === 0" class="mdi mdi-trophy first"></span>
              <span v-else-if="index === 1" class="mdi mdi-trophy second"></span>
              <span v-else-if="index === 2" class="mdi mdi-trophy third"></span>
              <span v-else class="mdi mdi-emoticon-sad"></span>
            </th>
            <th>{{ index+1 }}</th>
            <td>
              <router-link
                :to="{name: 'User', params: { username: user.username }}">
                {{ user.username }}
              </router-link>
            </td>
            <td>{{ user.xp }}xp</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import ApiUsers from '@/api/users'
export default {
  data () {
    return {
      users: []
    }
  },
  created () {
    ApiUsers.get.leaderboard().then(response => {
      this.users = response.body
    })
  }
}
</script>

<style scoped>
.leaderboard {
  justify-content: center;
}
.first {
  color: gold;
}
.second {
  color: silver;
}
.third {
  color: sandybrown;
}
</style>



// WEBPACK FOOTER //
// src/components/Leaderboard.vue